import type { ReactElement, ReactNode } from "react";

const sizes = { 12: "size-3", 16: "size-4", 20: "size-5", 24: "size-6" } as const;

export interface SpinnerProps {
  readonly size?: keyof typeof sizes;
  readonly label?: string;
}

export const Spinner = ({ size = 16, label }: SpinnerProps): ReactElement => {
  const semantics = label === undefined ? { "aria-hidden": true } : { role: "status", "aria-label": label };
  return (
    <span className={`inline-block shrink-0 ${sizes[size]}`} {...semantics}>
      <svg viewBox="0 0 16 16" className="size-full animate-spin" fill="none">
        <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeOpacity="0.2" strokeWidth="1.5" />
        <path d="M14.5 8A6.5 6.5 0 0 0 8 1.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </span>
  );
};

export interface PendingLabelProps {
  readonly isPending: boolean;
  readonly children: ReactNode;
}

// WHY: the label stays in place, transparent but still named, so a pending control keeps its width.
export const PendingLabel = ({ isPending, children }: PendingLabelProps): ReactElement => (
  <span className="relative inline-flex items-center justify-center">
    <span className={isPending ? "opacity-0" : undefined}>{children}</span>
    {isPending && (
      <span className="absolute inset-0 flex items-center justify-center">
        <Spinner size={16} />
      </span>
    )}
  </span>
);
